import { Button, ButtonProps } from "@mui/material";
import React from "react";
import "./PrimaryButton.css";

interface PrimaryButtonProps extends ButtonProps {
  children: React.ReactNode;
  href?: string;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  href,
  className = "",
  ...props
}) => {
  return (
    <Button
      className={`primary-button ${className}`}
      variant="contained"
      component={href ? "a" : "button"}
      href={href}
      sx={{
        border: '1px solid rgba(0, 0, 0, 0.1)',
        '&:hover': {
          border: '1px solid rgba(0, 0, 0, 0.2)',
        },
        ...props.sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
